import Form from "../../components/forms/form";
import {AnalyticsService} from "../../services/analytics-service";
import ModalForm from "../../components/forms/modal-form";
import NetworkService from "../../services/network-service";

export default class FormController {
    constructor() {
        this.initWebinarRegistrationForm();
        this.initWebinarRegistrationStaticForm();
    }

    initWebinarRegistrationForm() {
        const $placeholder = document.getElementById('webinar-registration-placeholder');

        if (!$placeholder) {
            return;
        }

        NetworkService.get(`${NetworkService.apiSiteUrl}/feed/teens/webinar-registration`, {
            entry: craft.page.entryId
        }).then((response) => {
            if (!response && !response.trim()) {
                return;
            }

            $placeholder.insertAdjacentHTML('afterend', response.trim());
            $placeholder.remove();
            const $triggers = document.querySelectorAll('[data-modal-trigger="webinar-registration"]');

            if (!$triggers.length) {
                return;
            }

            this.webinarRegistrationForm = new ModalForm({
                $modalTriggers: Array.from($triggers),
                formId: 'webinar-registration',
                uri: '/2.0/blog/event/registration',
                data: {
                    branding: 'bookford',
                    fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                    fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                    referrer: location.href,
                    eventId: craft.page.entryId,
                    source: 'registration'
                },
                subscriptions: [
                    {
                        // Update custom fields data to format { label, value }
                        event: 'beforeSubmit',
                        callback: ({ detail }) => {
                            const dataLayerEventData = {
                                event: 'register_for_event_form',
                                formId: this.webinarRegistrationForm.formId,
                                phone: this.webinarRegistrationForm.data.tel,
                                email: this.webinarRegistrationForm.data.email
                            };

                            AnalyticsService.sendEvent('register_for_event_form', dataLayerEventData);
                        }
                    }
                ]
            });
        });
    }

    initWebinarRegistrationStaticForm() {
        if (!document.getElementById('form-webinar-registration-static')) {
            return;
        }

        this.webinarRegistrationStaticForm = new Form({
            formId: 'webinar-registration-static',
            uri: '/2.0/blog/event/registration',
            data: {
                branding: 'bookford',
                fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                referrer: location.href,
                eventId: craft.page.entryId,
                source: 'registration'
            },
            subscriptions: [
                {
                    // Update custom fields data to format { label, value }
                    event: 'beforeSubmit',
                    callback: ({ detail }) => {
                        const dataLayerEventData = {
                            event: 'register_for_event_form',
                            formId: this.webinarRegistrationStaticForm.formId,
                            phone: this.webinarRegistrationStaticForm.data.tel,
                            email: this.webinarRegistrationStaticForm.data.email
                        };

                        AnalyticsService.sendEvent('register_for_event_form', dataLayerEventData);
                    }
                }
            ]
        });
    }
}